<template>
	<div class="home">
		<van-nav-bar
		  	:title="$t('center.platformList')"
			left-arrow
			fixed
			z-index='9'
		  	@click-left="$router.push('/Center')">
			<van-icon name="./static/img/add_staff.png" slot="right" @click="$router.push('/PlatformBind')" style="font-size: 24px;"/>
		</van-nav-bar>
		<div class="shopList">
			<template v-for="(shop,index) in shops">
                <van-cell center :title="shop.name" @click="goShop(shop.link);">
                    <template #icon>
                        <van-icon :name="shop.image" size="65" style="margin-right: 10px;"/>
                    </template>
                    <template slot="right-icon">
				    	<div class="tagSort">
                            <van-icon @click.stop="onAction(shop.id, 'down');" size="25px" name="./static/img/down1.png" />   
                            <van-icon @click.stop="onAction(shop.id, 'up')" size="25px" name="./static/img/up.png" />
                            <van-icon @click.stop="unBind(shop.store_id)" size="25px" name="./static/img/minus.png" />
                            <van-icon name="arrow" size="25px" @click.stop="goShop(shop.link);"/>   
                    	</div>
				    </template>
                </van-cell>
            </template>
		</div>
	</div>
</template>

<script>
export default {
    data () {
      	return {
      		shops:[],
      	}
    },
    mounted:function(){
		this.getShops();
    },
    computed:{

    },
    methods:{
    	getShops(){
    		this.$axios({
                method: 'get',
                headers: {
                    "Authorization": 'Bearer '+sessionStorage.token,
                },
                url: this.$build+'/api/user/indexBind',
            }).then(res => {
            	console.log(res);
            	if(res.data.status==200){
                	this.shops=res.data.data;
            	}else{
            		for (var item in res.data.error) {
            			this.$toast({
		            		type:'fail',
		            		message:res.data.error[item],
		            	});
            		}
            	}
            }).catch(err => {
            	this.$toast({
            		type:'fail',
            		message:this.$t('ShopList.message'),
        		});
            });
    	},
    	onAction(id,type){
    		this.$axios({
                method: 'post',
                headers: {
                    "Authorization": 'Bearer '+sessionStorage.token,
                },
                url: this.$build+'/api/user/orderBind',
                data: {
                	id: id,
                	action: type,// 动作：【up：上移，down：下移】
                },
            }).then(res => {
            	console.log(res);
            	if(res.data.status==200){
                	this.shops=res.data.data;
            	}else{
            		for (var item in res.data.error) {
            			this.$toast({
		            		type:'fail',
		            		message:res.data.error[item],
		            	});
            		}
            	}
            }).catch(err => {
            	this.$toast({
            		type:'fail',
            		message:this.$t('ShopList.message'),
        		});
            });
    	},
    	unBind(id){
    		this.$axios({
                method: 'post',
                headers: {
                    "Authorization": 'Bearer '+sessionStorage.token,
                },
                url: this.$build+'/api/user/binding',
                data: {
                	store_id: id,
                	type: 'reduce',// 类型：【add：添加，reduce：减少、删除】
                },
            }).then(res => {
            	console.log(res);
            	if(res.data.status==200){
            		this.$toast({
	            		type:'success',
	            		message:'解绑成功',
	            	});
                	// this.shops=res.data.data;
                	this.getShops();
            	}else{
            		for (var item in res.data.error) {
            			this.$toast({
		            		type:'fail',
		            		message:res.data.error[item],
		            	});
            		}
            	}
            }).catch(err => {
            	this.$toast({
            		type:'fail',
            		message:this.$t('ShopList.message'),
        		});
            });
    	},
    	goShop(link){
            if(link){
                window.open(link);
            }
    	}
    }
}
</script>
<style>
	.addShop .van-grid-item__content{
		padding: 0;
	}
	.addShop .van-image{
		margin: auto;
	}
</style>
<style scoped>
	/deep/ .van-nav-bar .van-icon{
		font-size: 24px;
		color: #fff;
	}
	.home{
		width: 100%;
		min-height: 100vh;
		background: #f3f3f3;
	}
	.shopList{
		padding-top: 53px;
	}
	/deep/ .van-grid-item__content p{
		font-size: 12px;
		text-align: center;
		margin: 0;
		padding: 0;
	}
	/deep/ .van-grid-item__content{padding:0;border-radius: 5px;padding-bottom: 10px;align-items: center;-webkit-align-items:center; justify-content:flex-start;}
	.van-grid-item__content p.shopname{
		font-size: 15px;
	}
	.shopname1{
		height: 36px;
		align-items: center;
		display: inline-flex;
	}
	.shopname{
		line-height: 18px;
		align-items: center;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		overflow: hidden;
	}
	.shoptime{
		font-size: 12px;
		color: #d4d4d4;
	}
	.shoptime span{color: rgb(253, 63, 63);}
	.van-image{
		align-items: center;
		-webkit-align-items:center;
	}
	.van-image__img{
		vertical-align:middle;
	}
	.shopIcon{
		margin:10px 0;
	}
	.shopBj{
		width: 100%;
		border-radius: 5px 5px 0 0;
		text-align: center;	
	}
	.tagSort{
		width: 110px;
		/*width: 86px;*/
		display: flex;
        justify-content: space-around;
	}
</style>



// WEBPACK FOOTER //
// src/Platform/PlatformList.vue